export default function initPrototypes() {

	/**
	 * Checks if a string is a valid email address
	 * @return {boolean} true if the string is a valid email address, false otherwise
	 */
	String.prototype.isValidEmail = function () {
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this);
	}

	/**
	 * Formats the text by replacing specific symbols with SVG icons and converting newlines to <br> tags.
	 *
	 * @returns {HTMLElement} The formatted HTML element.
	 */
	HTMLElement.prototype.TI_format = function () {
		const svgGood = '<span class="ti-prokontra-good"><svg viewBox="0 0 128 128"><path d="M64 8a56 56 0 1 0 56 56A56 56 0 0 0 64 8zm0 104a48 48 0 1 1 48-48 48 48 0 0 1-48 48zM44 64a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm48-8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-4.8 21.6a4 4 0 0 1 .6 3.6A24.3 24.3 0 0 1 64 97c-9.7 0-15.7-4.2-19-7.8a22.7 22.7 0 0 1-4.8-8A4 4 0 0 1 44 76h40a4 4 0 0 1 3.2 1.6z"></path></svg></span>';
		const svgBad = '<span class="ti-prokontra-bad"><svg viewBox="0 0 128 128"><path d="M64 8a56 56 0 1 0 56 56A56 56 0 0 0 64 8zm0 104a48 48 0 1 1 48-48 48 48 0 0 1-48 48zM44 64a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm48-8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-5.2 30.2a4 4 0 1 1-5.6 5.6c-10.5-10.4-24-10.4-34.4 0a4 4 0 0 1-5.6-5.6c13.6-13.7 32-13.7 45.6 0z"></path></svg></span>';

		// Replace symbols with SVG icons
		// let formattedText = this.innerHTML.replace(/^☺/m, svgGood).replace(/^☹/m, svgBad);
		let formattedText = String(this.innerHTML).replace(/☺/g, svgGood).replace(/☹/g, svgBad);

		// Convert newlines to <br> tags
		formattedText = formattedText.trim().replace("</strong>\n", "</strong>").replace(/\n/g, "<br />");

		this.innerHTML = formattedText;

		return this;
	};

	/**
	 * Shortens the text content of a DOM element by truncating it with an ellipsis.
	 * @param {Object} [options] - An object that contains one or more of the following properties:
	 * @param {number} [options.showLines=2] - The number of lines to show.
	 * @param {string} [options.ellipsesText="..."] - The text to display for the ellipsis.
	 * @param {string} [options.moreText="more"] - The text for the "more" link.
	 * @param {string} [options.lessText="less"] - The text for the "less" link.
	 */
	HTMLElement.prototype.TI_shorten = function (options = {}) {
		const config = {
			showLines: 2,
			ellipsesText: "...",
			moreText: "more",
			lessText: "less",
			...options
		};

		if (this.classList.contains("shortened")) return;

		this.classList.add("shortened");
		this.style.display = '-webkit-box';
		this.style.overflow = 'hidden';
		this.style.webkitBoxOrient = 'vertical';
		this.style.webkitLineClamp = config.showLines.toString();

		if (this.scrollHeight - this.clientHeight > 5) {
			const btn = document.createElement('a');
			btn.href = "#";
			btn.style.textDecoration = "none";
			btn.style.display = "block";
			btn.className = "more-link";
			btn.innerHTML = config.moreText;

			this.insertAdjacentElement('afterend', btn);

			btn.addEventListener('click', (event) => {
				event.preventDefault();

				if (btn.innerHTML === config.moreText) {
					this.style.webkitLineClamp = "unset";
					this.style.overflow = 'visible';
					btn.innerHTML = config.lessText;
				} else {
					this.style.webkitLineClamp = config.showLines.toString();
					this.style.overflow = 'hidden';
					btn.innerHTML = config.moreText;
				}
			});
		}
	};

	/**
	 * Sets the icon of an element to a number with a prefix and suffix.
	 * @param {number} num - The number to display.
	 * @param {string} [prefix=''] - The prefix to add before the number.
	 * @param {string} [suffix=''] - The suffix to add after the number.
	 */
	HTMLElement.prototype.setIconCounter = function (num, prefix = '', suffix = '') {
		const element = this.querySelector('span');
		if (element) {
			if (num > 0) {
				element.innerHTML = prefix + num + suffix;
			} else {
				element.innerHTML = '';
			}
		}
	};
}